import { PropType, defineComponent } from "vue";
import { Flow } from "@mv/flow-shared-utils/types/flow";

type CloseOrDeleteAction = () => void;

export default defineComponent({
  name: "sdk-flow-delete-definition",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    definition: {
      type: Object as PropType<Flow.Process.Definition.definition>,
      required: true,
    },
    deleteAction: {
      type: Function as PropType<CloseOrDeleteAction>,
      required: true,
    },
    closeAction: {
      type: Function as PropType<CloseOrDeleteAction>,
      required: true,
    },
  },
});
